module.exports = __webpack_public_path__ + "img/post-job.85128402.jpg";